module.exports = __webpack_public_path__ + "img/basic_image.bc714d54.png";